import { API } from '@shared/types/api';
import { MBStackedUsers } from '../message/stackedUsers';

export interface MBSeenByImagesProps {
  users: API.ShortUserFragment[];
  isCountVisible?: boolean;
}

export function MBSeenByImages({ users, isCountVisible }: MBSeenByImagesProps) {
  return <MBStackedUsers users={users} small isCountVisible={isCountVisible} />;
}
